import React, { Component, Fragment } from "react";
import Table from "./table";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Form from "./form";
import i18n from "../../../../i18n";
import { Tab, Tabs } from "react-bootstrap";
import FormAll from "./form-all";

const MySwal = withReactContent(Swal);
export class MutationData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      click: 0,
      search: {
        limit: 10,
      },
      titleModal: "",
      listData: [],
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), className: " text-gray-600" },
        { link: null, title: i18n.t("Mutation"), className: " text-gray-500" },
      ],
      columns: [
        {
          key: "date",
          filter: { active: true, type: "Date", data: null },
          title: i18n.t("Date"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        {
          key: "beginningStock",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Beginning Stock"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        {
          key: "beginningBalance",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Beginning Balance"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        {
          key: "qtyIn",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Qty In"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        {
          key: "totalIn",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Balance In"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        {
          key: "qtyOut",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Qty Out"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        {
          key: "totalOut",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Balance Out"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        {
          key: "endingStock",
          filter: { active: false, type: "Text", data: null },
          title: "Ending Stock",
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        {
          key: "endingBalance",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Ending Balance"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        {
          key: "description",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Remark"),
          type: "text",
          tHclass: "",
          tdClass: "",
        },
        
      ],
    };
  }

  renderTable() {
    if(this.state.listData != null && this.state.listData != [] && this.state.listData != undefined){
      return this.state.listData.map((data, i) => (
        <Fragment key={i}>
          <Table {...this.props} data={data} columns={this.state.columns}></Table>
        </Fragment>
      ));
    }
  }
  
  render() {
    const { isProcessing, data, onChoose } = this.props;

    if (onChoose && this.state.click == 0) {
      this.state.listData = data;
      this.state.click = 1;
    }
    if (!onChoose && this.state.click > 0) {
      this.state.click = 0;
    }
    return (
      <div id="invoice-page">
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-body pt-8">
                  <Form
                    {...this.props}
                    data={data}
                  />
                 {isProcessing && onChoose == false?<div className="text-center">
                  <div className="spinner-border  text-primary text-center  clearfix"></div>
                  <div className="text-center">{i18n.t("Loading")}</div>
                  </div>:null}
              </div>
             
            </div>
            {onChoose ? this.renderTable() : ""}
          </div>
        </div>
      </div>
    );
  }
}

export default MutationData;
